import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ABTestingExample from './ABTestingExample'
import PulseExample from './PulseExample'
import MultipleChoiceExample from './MultipleChoiceExample'
import MCExample from './MCExample'
import { useEffect } from 'react'

const Examples = ({ showSpecificSection }) => {

  useEffect(() => {
    if (showSpecificSection) {
      const element = document.getElementById(`${showSpecificSection}Example`)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [showSpecificSection])

  return (
    <>
      <b>
        Each Section will have A/B Options, Prompts and Sliders, Multiple
        Choice, and Multiple Choice Grid
      </b>
      <br />
      <br />
      <Accordion
        sx={{
          marginBottom: 0,
          border: showSpecificSection === 'ABTesting' && '2px solid',
          borderColor: 'secondary.main'
        }}
        defaultExpanded={
          !showSpecificSection || showSpecificSection === 'ABTesting'
        }
        id='ABTestingExample'
      >
        <AccordionSummary
          sx={{
            textAlign: 'left',
            fontWeight: 'bold'
          }}
          expandIcon={<ExpandMore />}
        >
          For Sections with A/B Options, click on an option to respond:
        </AccordionSummary>
        <AccordionDetails>
          <ABTestingExample />
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: 0,
          border: showSpecificSection === 'Slider' && '2px solid',
          borderColor: 'secondary.main'
        }}
        defaultExpanded={
          !showSpecificSection || showSpecificSection === 'Slider'
        }
        id='SliderExample'
      >
        <AccordionSummary
          sx={{
            textAlign: 'left',
            fontWeight: 'bold'
          }}
          expandIcon={<ExpandMore />}
        >
          For Sections with Prompts and Sliders, click on an option or on the
          slider to respond to each prompt:
        </AccordionSummary>
        <AccordionDetails>
          <PulseExample />
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: 0,
          border: showSpecificSection === 'MC' && '2px solid',
          borderColor: 'secondary.main'
        }}
        defaultExpanded={!showSpecificSection || showSpecificSection === 'MC'}
        id='MCExample'
      >
        <AccordionSummary
          sx={{
            textAlign: 'left',
            fontWeight: 'bold'
          }}
          expandIcon={<ExpandMore />}
        >
          For Multiple Choice, select your preferred responses and click Save.
          You may click Save without selecting any options, if none apply:
        </AccordionSummary>
        <AccordionDetails>
          <MCExample />
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          marginBottom: 0,
          border: showSpecificSection === 'MultipleChoice' && '2px solid',
          borderColor: 'secondary.main'
        }}
        defaultExpanded={
          !showSpecificSection || showSpecificSection === 'MultipleChoice'
        }
        id='MultipleChoiceExample'
      >
        <AccordionSummary
          sx={{
            textAlign: 'left',
            fontWeight: 'bold'
          }}
          expandIcon={<ExpandMore />}
        >
          For Multiple Choice Grid, select a response for each prompt then click
          Save:
        </AccordionSummary>
        <AccordionDetails>
          <MultipleChoiceExample />
        </AccordionDetails>
      </Accordion>
      <br />
    </>
  )
}

export default Examples
